const DASHBOARD_CONTACT_GROUPS = new Set(["party", "lawyer"]);
const DASHBOARD_ACTUACION_CATEGORIES = new Set([
  "actuaciones",
  "escritos",
  "cedulas",
]);

function occurredAtTimestamp(item) {
  const timestamp = new Date(item?.occurredAt || 0).getTime();
  return Number.isFinite(timestamp) ? timestamp : 0;
}

export function selectDashboardContacts(entries = []) {
  return entries
    .filter((entry) =>
      !entry?.historical && DASHBOARD_CONTACT_GROUPS.has(entry?.group))
    .sort((left, right) =>
      (left.group === right.group ? 0 : left.group === "party" ? -1 : 1) ||
      String(left.name || "").localeCompare(String(right.name || ""), "es"));
}

export function selectDashboardActuaciones(items = [], limit = 10) {
  return items
    .filter((item) =>
      item?.entryType === "actuacion" &&
      !item.esMovimiento &&
      DASHBOARD_ACTUACION_CATEGORIES.has(item.category))
    .sort((left, right) =>
      occurredAtTimestamp(right) - occurredAtTimestamp(left) ||
      String(left.entryId || "").localeCompare(String(right.entryId || "")))
    .slice(0, limit);
}
